<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col
        v-if="canEdit"
        class="text-end"
      >
        <v-btn
          color="primary"
          outlined
          @click="
            () => {
              $refs.ColorForm.openDialog();
            }
          "
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Colour
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            id="movements-table"
            :headers="colorsHeaders"
            :items="colors"
            :footer-props="itemsTableFooterProps"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #item="{ item }">
              <tr>
                <td :class="{ 'red-theme': item.enabled == 0 }">
                  <TextHighlight :queries="search">
                    {{ item.id }}
                  </TextHighlight>
                </td>
                <td :class="{ 'red-theme': item.enabled == 0 }">
                  <TextHighlight :queries="search">
                    {{ item.code }}
                  </TextHighlight>
                </td>
                <td :class="{ 'red-theme': item.enabled == 0 }">
                  <TextHighlight :queries="search">
                    {{ item.name }}
                  </TextHighlight>
                </td>
                <td :class="{ 'red-theme': item.enabled == 0 }">
                  <TextHighlight :queries="search">
                    {{ item.created_at }}
                  </TextHighlight>
                </td>
                <td :class="{ 'red-theme': item.enabled == 0 }">
                  <TextHighlight :queries="search">
                    {{ item.updated_at }}
                  </TextHighlight>
                </td>
                <td style="text-align:right">
                  <v-btn
                    class="ml-1 mt-1 mb-1"
                    color="primary"
                    outlined
                    small
                    @click="openProfileForm(item)"
                  >
                    EDIT
                  </v-btn>
                  <v-btn
                    v-if="item.enabled == 1"
                    class="ml-1 mt-1 mb-1"
                    color="purple"
                    outlined
                    small
                    @click="disable(item.id)"
                  >
                    DISABLE
                  </v-btn>
                  <v-btn
                    v-else
                    class="ml-1 mt-1 mb-1 pl-5"
                    color="purple"
                    outlined
                    small
                    @click="enable(item.id)"
                  >
                    ENABLE
                  </v-btn>
                  <v-btn
                    class="ml-1 mt-1 mb-1"
                    color="error"
                    outlined
                    small
                    @click="deleted(item.id)"
                  >
                    DELETE
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Snackbar ref="snackbar" />
    <ColorForm
      ref="ColorForm"
      @profile-creation-success="notifyProfileCreationSuccess"
      @profile-creation-fail="notifyProfileCreationFail"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import TextHighlight from 'vue-text-highlight';
import { mapState } from 'vuex';
import Snackbar from '../../components/Snackbar';
import ColorForm from '../../components/forms/ColorForm';
import ColorsApi from '../../api/ColorsApi';

export default {
  name: 'Profiles',
  components: {
    Snackbar,
    TextHighlight,
    ColorForm,
  },
  filters: {},
  data: () => ({
    loading: true,
    itemsTableFooterProps: {
      'items-per-page-options': [10, 20, 50, -1],
    },
    colorsHeaders: [
      { text: 'Colour ID', value: 'id' },
      { text: 'Colour Code', value: 'code' },
      { text: 'Colour Name', value: 'name' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Updated At', value: 'updated_at' },
      { text: 'Actions', align: 'end' },
    ],
    colors: [],
    canEdit: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  created() {
    this.initialize();
    this.canEdit = this.$store.getters.userCanEdit;
  },
  methods: {
    async initialize() {
      Promise.all([this.fetchProfiles()]);
    },
    openProfileForm(item) {
      this.$refs.ColorForm.openDialog(item);
    },
    showBoms(item, type) {
      this.$emit('show-boms', item.id, type);
    },
    notifyProfileCreationSuccess() {
      this.$refs.snackbar.showSuccess('Success!');
      this.fetchProfiles();
    },
    notifyProfileCreationFail() {
      this.$refs.snackbar.showError('Something went wrong!');
    },
    async fetchProfiles() {
      this.loading = true;

      const submitModel = {
        filters: {
          is_not_enabled_filter: 1,
        },
      };

      this.colors = await this.$api.color.read(submitModel);
      this.loading = false;
    },
    openProfile(item) {
      this.$router.push(`/profile/${item.code}`);
    },
    convertedPhoto(photo, mimeType) {
      return `data:${mimeType};base64, ${photo}`;
    },
    async deleted(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;

      const data = new FormData();
      data.append('id', id);
      data.append('deleted', 1);
      const res = await ColorsApi.store(data);
      if (res) {
        this.$emit('profile-creation-success');
      } else {
        this.$emit('profile-creation-fail');
      }
      this.fetchProfiles();
    },
    async enable(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to enable this record?',
      });
      if (!confirm) return;
      const data = new FormData();
      data.append('id', id);
      data.append('enabled', 1);
      const res = await ColorsApi.store(data);
      if (res) {
        this.$emit('profile-creation-success');
      } else {
        this.$emit('profile-creation-fail');
      }
      this.fetchProfiles();
    },
    async disable(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to disable this record?',
      });
      if (!confirm) return;
      const data = new FormData();
      data.append('id', id);
      data.append('enabled', 0);
      const res = await ColorsApi.store(data);
      if (res) {
        this.$emit('profile-creation-success');
      } else {
        this.$emit('profile-creation-fail');
      }
      this.fetchProfiles();
    },

  },

};
</script>
<style scoped>
.profile-photo{
  max-width: 100px;
}
.text-right{
  width: 85px!important;
}
.red-theme{
  color: #fa7575!important;;
}</style>
